export class LocalStorageKeys {
  public static readonly ID_TOKEN = 'idToken';
  public static readonly ACCESS_TOKEN = 'accessToken';
  public static readonly REFRESH_TOKEN = 'refreshToken';
  public static readonly AUTH_SESSION = 'authSession';
  public static readonly EXPIRATION = 'expires';
  public static readonly WORKING_CONTAINER = 'workingContainer';
  public static readonly CONTAINERS_LIST = 'containersList';
  public static readonly CONTAINER_UPE_ID = 'containerUpeId';
  public static readonly CONTAINER_UPE_CURRENCY = 'containerUpeCurrency';
  public static readonly CONTAINER_UPE_CURRENCY_SCALE = 'containerUpeCurrencyScale';
  public static readonly USER = 'user';
  public static readonly COUNTRIES = 'countries';
  public static readonly ROLE = 'role';
  public static readonly WORKSPACE_CHOICE = 'workspaceChoice';
  public static readonly MFA_ENABLED = 'mfaEnabled';
  public static readonly REDIRECT_FLAG = 'redirectFlag';
  public static readonly PRODUCT_UUID = 'productUuid';
}
